export default {
	list: 'FMVStatementReport',
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		TaxId : {
			class: "value",
			dataName: 'TaxId',
			type: 'string',
			title: 'Tax ID',
			width: 100,
			hidden: false,
			readOnly: false			
		},
		PartnerId: {
			class: "lookup",
			dataName: 'PartnerId',
			type: 'number',
			title: 'Partner ID',
			width: 100,
			hidden: true,
			readOnly: false
		},
		PartnerPartnerID: {
			class: "lookup",
			dataName: 'Partner/PartnerID',
			type: 'number',
			title: 'Partner ID',
			width: 100,
			hidden: false,
			readOnly: true
		},
		PartnerFullName: {
			class: "lookup",
			dataName: 'Partner/FullName',
			type: 'string',
			title: 'Partner Name',
			width: 100,
			hidden: false,
			readOnly: true
		},
		TaxYear: {
			class: 'value',
			dataName: 'TaxYear',
			type: 'number',
			title: 'TaxYear',
			width: 100,
			hidden: true,
			readOnly: false
		},
		TaxQuarter: {
			class: "value",
			dataName: 'TaxQuarter',
			type: 'string',
			title: 'Tax Quarter',
			width: 100,
			hidden: true,
			readOnly: false
		},
		TaxYearQuarter: {
			class: 'value',
			dataName: 'TaxYearQuarter',
			type: 'string',
			title: 'Tax Period',
			width: 100,
			hidden: false,
			readOnly: true
		},
		Status: {
			class: 'choice',
			dataName: 'Status',
			type: 'string',
			title: 'Status',
			width: 100,
			hidden: false,
			readOnly: false
		},
		DownloadLink: {
			class: 'lookup',
			dataName: 'DownloadLink',
			type: 'string',
			title: 'Download Link',
			width: 100,
			hidden: true,
			readOnly: false
		},
		Modified: {
			class: 'lookup',
			dataName: 'Modified',
			type: 'date',
			title: 'Date Completed',
			width: 100,
			hidden: false,
			readOnly: true
		},		
	}
}